import React, { Fragment, lazy, useEffect, useState, Suspense, startTransition } from "react";
import useAnalytics from "./useAnalytics";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min.js";
import axios from "axios";

const BrowserRouter = require("react-router-dom").BrowserRouter;
const Switch = require("react-router-dom").Switch;
const Route = require("react-router-dom").Route;

const Blog = lazy(() => import("./components/blog/blog"));
const AboutUsMain = lazy(() => import("./components/about-new/about-us"));
const ContactUsMain = lazy(() => import("./components/contact-new/contact-us"));
const PrivacyPolicyMain = lazy(() => import("./components/privacy-new/privacy-policy"));
const HomeMain = lazy(() => import("./components/home-new/home-new.js"));
const LatestCategory = lazy(() => import("./components/latest-category/latest-category"));
const CategoryAll = lazy(() => import("./components/category/category"));
const Error404 = lazy(() => import("./components/error-pages/error404"));

function AppRoutes() {
    useAnalytics();
    const [articleId, setArticleId] = useState(null);
    const [loading, setLoading] = useState(true);
    // const randomId = Math.floor(Math.random() * 40125) + 1;
    // console.log(randomId);
    const fetchRandomArticle = async () => {
        try {
            const res = await axios.get(`https://stgapi.thefactmagic.com/random/byte`);
            startTransition(() => {
            setArticleId(res?.data)
            console.log(res?.data); 
            }); 
        } catch (error) {
            console.error("Error fetching article id:", error);
        } finally {
                setLoading(false);
            }
    }
    useEffect(()=>{
        fetchRandomArticle();
    },[])
    return (
        <Fragment>
            <BrowserRouter>
            <Suspense fallback={<div id="loaderSD">Loading...</div>}>
                <Switch>
                    {/* <Route path="/" exact component={HomeMain} /> */}
                    
                    <Route exact path="/" render={(props)=> {
                       // Wait until API response is received
                            if (loading) {
                                return <div id="loaderSD">Loading...</div>;
                            }

                            // If API fails, show 404
                            if (!articleId) {
                                return <Error404 />;
                            } 
                            return (
                                <Redirect 
                                to = {`/byte${articleId}?utm_source=Transsion&article_type=1`}
                                />
                                // <Blog 
                                //     {...props}
                                //     articleId={articleId}
                                //     utm_source="Transsion"
                                //     article_type="1"
                                // />
                            );
                    }} />
                    
                    <Route exact path="/byte:article_id/" component={Blog} /> {/*For query string url*/}

                    <Route exact path="/:categorie1/:articleId/:id?utm_source=:utm_source&utm_medium=:utm_medium&utm_campaign=:utm_campaign&article_type=:article_type" component={Blog} />
                    <Route exact path="/:categorie1/:articleId/:id?utm_source=:utm_source&utm_medium=:utm_medium&utm_campaign=:utm_campaign" component={Blog} />
                    <Route exact path="/:categorie1/:articleId/:id" component={Blog} /> {/*For query string url*/}
                    <Route exact path="/aboutus" component={AboutUsMain} />
                    <Route exact path="/contactus" component={ContactUsMain} />
                    <Route exact path="/privacy-policy" component={PrivacyPolicyMain} />
                    <Route exact path="/latest/category/:utm_source/:ad_id" component={LatestCategory} />
                    <Route exact path="/category/:catId/:utm_source/:ad_id" component={CategoryAll} />
                    <Route  path="*" component={Error404} />
                </Switch>
                </Suspense>
            </BrowserRouter>
        </Fragment>
    );
}

export default AppRoutes;
